import React, { useState } from "react";
import style from "./Formulario.module.scss";
import axios from "axios";

import { Formik, Field, ErrorMessage, Form } from "formik";

export default function Formulario({ translation }) {
  const [confirm, setConfirm] = useState({
    message: "",
    visible: null,
  });

  return (
    <Formik
      initialValues={{
        name: "",
        email: "",
        message: "",
      }}
      onSubmit={async (valores, { resetForm }) => {
        let { name, email, message } = valores;

        try {
          await axios.post(
            "https://portfolio-backend-gules.vercel.app/send-email",
            {
              name,
              email,
              message,
            }
          );
        } catch (error) {
          console.log(error);
        }
        setConfirm({ message: "Successfully Sent", visible: true });
        setTimeout(() => {
          setConfirm({ message: "", visible: null });
        }, 2000);
        resetForm();
      }}
      validate={(valores) => {
        let errores = {};

        if (!valores.name) {
          errores.name = translation("contact.error-name");
        }
        if (!valores.email) {
          errores.email = translation("contact.error-email");
        } else if (
          /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/.test(
            valores.email
          )
        ) {
          errores.email = "Enter a valid email";
        }
        if (!valores.message) {
          errores.message = translation("contact.error-message");
        }

        return errores;
      }}
    >
      {({ errors }) => (
        <Form className={style.container} data-aos="fade-up">
          <div className={style.container__group}>
            <Field
              className={style.container__group_input}
              type="text"
              id="name"
              name="name"
              placeholder={translation("contact.input-name")}
            />
            <ErrorMessage
              name="name"
              component={() => (
                <p className={style.container__group_error}>{errors.name}</p>
              )}
            />
          </div>
          <div className={style.container__group}>
            <Field
              className={style.container__group_input}
              type="email"
              id="email"
              name="email"
              placeholder="Email"
            />
            <ErrorMessage
              name="email"
              component={() => (
                <p className={style.container__group_error}>{errors.email}</p>
              )}
            />
          </div>
          <div className={style.container__group}>
            <Field
              className={`${style.container__group_input} ${style.container__group_textarea}`}
              as="textarea"
              type="text"
              id="message"
              name="message"
              placeholder={translation("contact.input-message")}
            />
            <ErrorMessage
              name="message"
              component={() => (
                <p className={style.container__group_error}>{errors.message}</p>
              )}
            />
          </div>
          <button type="submit" className={style.container__button}>
            {translation("contact.btn-send")}
          </button>
          {confirm ? (
            <div className={style.container__sucess}>
              <p>{confirm.message}</p>
            </div>
          ) : null}
        </Form>
      )}
    </Formik>
  );
}
